import { render, staticRenderFns } from "./ConversationsList.vue?vue&type=template&id=0d5ace2f&"
import script from "./ConversationsList.vue?vue&type=script&lang=js&"
export * from "./ConversationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports